import React from "react";
import {
  DescriptionBox,
  IntroContainer,
  IntroLayoutWrapper,
  ItemContainer,
  ItemsContainer,
  ImageBlock,
  LogoBox,
  LogoContainer,
  TitleBox,
} from "./styles";
import Html from "../html/html";
import Button from "../button/button";
import { useApp } from "../../state/app";
import { Answer, ImageProps, LocaleValue } from "../../types";
import Animate from "../animate/animate";
import { MODE } from "../../config/consts";
import scorm from "../../services/scorm";

type Props = {
  image: ImageProps;
  title: LocaleValue;
  primaryColor: string;
  description: LocaleValue;
  startButtonText: string;
  startButtonBackground: string;
  backgroundColor: string;
  startButtonColor?: string;
  companyLogo: ImageProps;
  companyLogoAlt: LocaleValue;
  answers: Answer[];
  lastScene?: boolean;
};

export default function IntroLayout({
  image,
  title,
  backgroundColor = "#000",
  primaryColor = "#000",
  description,
  startButtonBackground,
  startButtonColor = "#fff",
  companyLogo,
  companyLogoAlt,
  answers,
  lastScene = false,
}: Props) {
  const { browser, language } = useApp();

  React.useMemo(() => {
    if (!title) return;
    document.title = title?.[language] ?? "";
  }, [title, language]);

  const focusRef = React.useRef<HTMLDivElement | null>(null);

  React.useEffect(() => {
    focusRef.current?.focus();
  }, []);

  React.useEffect(() => {
    if (lastScene) {
      window.parent.postMessage({ type: "course_completed" }, "*");
    }
    if (!MODE.startsWith("scorm")) return;
    if (!scorm.isConnected()) return;
    if (lastScene) {
      scorm.complete();
    }
  }, [lastScene]);

  return (
    <IntroLayoutWrapper
      style={{
        backgroundColor,
      }}
    >
      <Animate />
      <IntroContainer browser={browser}>
        <ImageBlock $bgImg={image.src}>
          {companyLogo?.src && (
            <LogoContainer>
              <LogoBox>
                <img
                  src={companyLogo.src}
                  alt={companyLogoAlt?.[language] || ""}
                />
              </LogoBox>
              <div></div>
            </LogoContainer>
          )}
          <TitleBox ref={focusRef}>
            <Html html={`<h1>${title?.[language]}</h1>`} />
          </TitleBox>
        </ImageBlock>
        <ItemsContainer>
          <ItemContainer>
            <DescriptionBox primaryColor={primaryColor}>
              <Html html={description?.[language]} />
              {answers.map((answer, index) => {
                return (
                  <Button
                    backgroundColor={startButtonBackground}
                    color={startButtonColor}
                    link={answer.sceneId}
                    key={index}
                  >
                    {answer?.text?.[language] ?? "Start"}
                  </Button>
                );
              })}
            </DescriptionBox>
          </ItemContainer>
        </ItemsContainer>
      </IntroContainer>
    </IntroLayoutWrapper>
  );
}
